import React from 'react';
import { Modal } from './Modal'; // Assuming you have a generic Modal component

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  confirmationText: string;
  title?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onClose, confirmationText, title = "Submission Received" }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      containerClassName="max-w-md p-4"
    >
      <div className="p-6 text-center">
        <h2 className="text-2xl font-bold text-blue-900 mb-4">{title}</h2>
        <p className="text-lg text-gray-700 mb-6">{confirmationText}</p>
        <button
          onClick={onClose}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
